import axios, { AxiosResponse } from 'axios';
import LRU from 'lru-cache';
import https from 'https';
import { GetRedirectsResponse } from '@/heplers/redirects';

const isServer = typeof process !== 'undefined' && process.server;

/* one shared cache per Node-process */
const treeCache: LRU<string, AxiosResponse> | null = isServer
  ? global.__TREE_CACHE__ ||
    (global.__TREE_CACHE__ = new LRU<string, AxiosResponse>({
      max: 2,
      maxAge: 1000 * 60, // 1 min
    }))
  : null;

const httpsAgent = isServer ? new https.Agent({ rejectUnauthorized: false }) : undefined;

const apiBase = process.env.VUE_APP_DOC_API_URL ?? '';
const apiSite = process.env.VUE_APP_SITE_API_URL ?? '';
const langRu = [process.env.VUE_APP_LANG, process.env.VUE_APP_PROD_LANG].includes('ru');
const isKit = process.env.VUE_APP_INSTANCE === 'kit';
const needRu = langRu && isKit;

export async function fetchRegion(userIp?: string): Promise<AxiosResponse> {
  try {
    return await axios.get(apiSite + 'getLoc', {
      httpsAgent,
      headers: userIp ? { 'X-Geo-Client-IP': userIp } : {},
    });
  } catch (e) {
    console.error(`fetchRegion error ${apiSite + 'getLoc'}`, e);
  }
}

export async function loadRedirects(): Promise<GetRedirectsResponse> {
  let arr: GetRedirectsResponse = [];

  try {
    const result = await axios.get(apiSite + 'getRedirects', {
      httpsAgent,
    });

    arr = result.data;
  } catch (error) {
    console.error('Failed to load redirects', error);
  }

  return arr;
}

export async function fetchPosts(
  url: string,
  params?: Record<string, string>
): Promise<AxiosResponse> {
  const pathWithParams = params ? `${url}?${new URLSearchParams(params).toString()}` : url;
  if (isServer && url === 'getTree') {
    const cached = treeCache.get(pathWithParams);
    if (cached) {
      return cached;
    }
  }

  const resp = await axios.get(apiBase + url, {
    httpsAgent,
    params: {
      ...params,
      ...(needRu ? { lang: 'ru' } : {}),
    },
  });

  if (isServer && url === 'getTree' && resp.status === 200) {
    treeCache.set(pathWithParams, resp);
  }

  return resp;
}

let currentSearchRequest: { cancel: (msg: string) => void; token: any } = null;

export async function fetchSearchRequest(searchString: string) {
  if (currentSearchRequest) currentSearchRequest.cancel('Operation canceled by the user.');
  currentSearchRequest = axios.CancelToken.source();

  try {
    const response = await axios.get(apiBase + searchString, {
      cancelToken: currentSearchRequest.token,
    });
    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.warn('Request canceled', error);
    }
  } finally {
    currentSearchRequest = null;
  }
}
